export default __webpack_public_path__ + "static/media/a016-market-3.3533abf1.jpg";